<app-generic-table-header [config]="headerOptions" (refreshEvent)="refreshTable($event)"
    (exportPressed)="exportReport($event)" (selectAllPressed)="selectAllPressed($event)"></app-generic-table-header>
<ng-template #prefixTemplate let-row>
    <app-card-table-actions [row]="row" (actionEvent)="selectDevice($event)" [breakpoint]="ScreenSize.TABLET">
    </app-card-table-actions>
</ng-template>
@if (devicesLoading) {
<div>
    <mat-spinner class="spinner" name="crescent"></mat-spinner>
</div>
}
<div>
    @if (devices && devices.length > 0 && !devicesLoading) {
    <app-card-table #Devices [data]="devices" [currentPage]="currentDevicePage" [totalItems]="totalDevices"
        [tableHeaders]="cdrTableHeaders" [options]="cdrTableOptions" [enableInfiteScroll]="false"
        [enableTablePagination]="true" [prefixTemplate]="prefixTemplate" (paginateEvent)="paginateDevices($event)"
        [breakpoint]="ScreenSize.TABLET" [enableRefresher]="false" [allSelected]="allDevicesSelected"
        (rowSelectedEvent)="onRowSelected($event)">
    </app-card-table>
    }
</div>
@if (!devicesLoading && devices.length == 0) {
<div class="centered">
    No devices to display
</div>
}